import { SvgIcon, SvgIconProps, useTheme } from "@mui/material";

const LambdaSvgIcon = ({ primary }: SvgIconProps & { primary?: boolean }) => {
  const { palette } = useTheme();

  const color = primary ? palette.primary.main : palette.action.active;

  return (
    <SvgIcon
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.63162 19.8H4.96202L9.01982 11.1444L10.8582 15.0084L8.63222 19.8H8.63162ZM9.28262 10.3212C9.25898 10.2707 9.2215 10.2281 9.17455 10.1981C9.1276 10.1682 9.07311 10.1522 9.01742 10.152H9.01622C8.96049 10.1527 8.90608 10.1691 8.85926 10.1993C8.81245 10.2296 8.77513 10.2724 8.75162 10.323L4.22882 19.971C4.20736 20.0168 4.19765 20.0672 4.20059 20.1177C4.20352 20.1682 4.219 20.2172 4.24562 20.2602C4.29962 20.3472 4.39382 20.4 4.49462 20.4H8.81822C8.93222 20.4 9.03602 20.3334 9.08522 20.2284L11.4516 15.135C11.4705 15.0943 11.4802 15.05 11.4799 15.0052C11.4797 14.9604 11.4697 14.9162 11.4504 14.8758L9.28262 10.3212ZM19.2108 19.8H15.6816L9.99962 7.37338C9.97644 7.32203 9.93903 7.2784 9.89181 7.24766C9.8446 7.21693 9.78956 7.20038 9.73322 7.19998H7.42202L7.42502 4.19998H11.9544L17.6088 16.626C17.6568 16.7322 17.7624 16.8 17.8764 16.8H19.2108V19.8ZM19.5048 16.2H18.0648L12.4104 3.77398C12.3872 3.72237 12.3496 3.67854 12.3022 3.64769C12.2547 3.61684 12.1994 3.60028 12.1428 3.59998H7.13102C7.0522 3.60077 6.97691 3.6328 6.92167 3.68905C6.86644 3.74529 6.83578 3.82115 6.83642 3.89998L6.83282 7.49998C6.83282 7.57918 6.86402 7.65538 6.91922 7.71238C6.94639 7.74004 6.97879 7.76202 7.01453 7.77706C7.05027 7.7921 7.08865 7.79989 7.12742 7.79998H9.54662L15.2274 20.2266C15.2754 20.3322 15.3798 20.4 15.4944 20.4H19.506C19.5451 20.3997 19.5837 20.3916 19.6196 20.3764C19.6556 20.3611 19.6882 20.3389 19.7155 20.3111C19.7429 20.2832 19.7645 20.2502 19.7791 20.214C19.7937 20.1778 19.801 20.139 19.8006 20.1V16.5C19.8006 16.3344 19.6692 16.2 19.506 16.2H19.5048Z"
        fill={color}
      />
    </SvgIcon>
  );
};

LambdaSvgIcon.muiName = "LambdaSvgIcon";

export default LambdaSvgIcon;
